import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of, switchMap, tap } from 'rxjs';
import { MabArticleModel, MabArticleResponseModel } from '../models/mab-article.model';
import { buildMabArticlesFromFeed } from '../utils/build-mab-articles-from-feed';

@Injectable({
  providedIn: 'root',
})
export class MabArticlesService {
  private http = inject(HttpClient);
  private articles: MabArticleModel[] = null;
  private ARTICLES_URL = 'https://mab-articles-proxy-100268918912.europe-west2.run.app/';

  getArticles(): Observable<MabArticleModel[]> {
    if (this.articles?.length) return of(this.articles);
    return this.fetchArticles().pipe(
      tap((data) => {
        this.articles = data || [];
      }),
    );
  }

  getArticleById(id: string): Observable<MabArticleModel> {
    if (this.articles?.length) return of(this.articles.find((a) => a.id === id));

    return this.fetchArticles().pipe(
      tap((data) => {
        this.articles = data || [];
      }),
      switchMap((data) => of(data.find((a) => a.id === id))),
    );
  }

  private fetchArticles(): Observable<MabArticleModel[]> {
    return this.http.get<MabArticleResponseModel>(this.ARTICLES_URL).pipe(switchMap((data) => of(buildMabArticlesFromFeed(data))));
  }
}
